import React, { Component } from 'react';
import styled from 'styled-components';
import { Parallax } from 'react-scroll-parallax';
import media from 'src/styles/media';

import DarkCircle from 'src/components/DarkCircle';
import RegisterButton from 'src/components/RegisterButton';
import NextLine from 'src/components/NextLine';
import DownArrow from 'src/components/DownArrow';

import imgMainTower from 'src/assets/images/building/streetview.jpg';
import imgLobby from 'src/assets/images/building/lobby.jpg';
import imgExterior from 'src/assets/images/building/courtyard.jpg';

class Building extends Component {
  render() {
    return (
      <Root>
        <Header image={imgMainTower}>
          <Circle>
            <p>The Building</p>
            <h1>Community Experience</h1>
          </Circle>
          <StyledParallax
            slowerScrollRate
            offsetYMax={-30}
            offsetYMin={30}
            desktopTop={'42%'}
            desktopLeft={'20%'}
          >
            <StyledDarkCircle
              mobileTop={'50%'}
              text={
                <p>
                  <span>Panoramic views</span> begin at the magnificent North
                  Shore Mountains, spanning to the grand expanse of the Fraser
                  Valley and iconic Mount Baker in the east, and gently rests
                  along the Georgia Strait and Gulf Islands in the west.
                </p>
              }
            />
          </StyledParallax>
          <StyledParallax
            slowerScrollRate
            offsetYMax={-30}
            offsetYMin={30}
            desktopTop={'60%'}
            desktopLeft={'60%'}
          >
            <StyledDarkCircle
              mobileTop={'72.5%'}
              text={
                <p>
                  Family residences, townhomes, street-level shops, and enhanced
                  landscaping have been <span>thoughtfully planned</span> to
                  engage the community.
                </p>
              }
            />
          </StyledParallax>
          <StyledParallax
            slowerScrollRate
            offsetYMax={-50}
            offsetYMin={10}
            disabled={window.innerWidth < 480}
            desktopTop={'80%'}
            desktopLeft={'15%'}
          >
            <MobileStyledDarkCircle
              mobileTop={'97%'}
              text={
                <p>
                  Enclosed SkyTrain tracks reduce noise and{' '}
                  <span>add greenspace</span> to create a more sustainable{' '}
                  <span>community for everyone.</span>
                </p>
              }
            />
          </StyledParallax>
          <StyledDownArrow />
        </Header>

        <MobileText>
          Enclosed SkyTrain tracks reduce noise, and added greenspace to create
          a more sustainable community for everyone.
        </MobileText>

        <Parallax
          offsetYMax={-20}
          offsetYMin={0}
          slowerScrollRate
          disabled={window.innerWidth < 480}
        >
          <Image image={imgLobby}>
            <StyledParallax
              slowerScrollRate
              offsetYMax={-30}
              offsetYMin={30}
              disabled={window.innerWidth < 480}
              desktopTop={'10%'}
              desktopLeft={'70%'}
            >
              <MobileStyledDarkCircle
                mobileTop={'55vw'}
                text={
                  <p>
                    The entry plaza and pocket park incorporate{' '}
                    <span>water features</span> to complement the{' '}
                    <span>broadened sidewalks.</span>
                  </p>
                }
              />
            </StyledParallax>
          </Image>
        </Parallax>

        <MobileText>
          The entry plaza and pocket park incorporate water features that
          complement the broadened sidewalks
        </MobileText>

        <Parallax
          offsetYMax={-40}
          offsetYMin={-10}
          slowerScrollRate
          disabled={window.innerWidth < 480}
        >
          <Image image={imgExterior} last={true}>
            <StyledParallax
              slowerScrollRate
              offsetYMax={-30}
              offsetYMin={30}
              disabled={window.innerWidth < 480}
              desktopTop={'20%'}
              desktopLeft={'20%'}
            >
              <MobileStyledDarkCircle
                mobileTop={'60vw'}
                text={
                  <p>
                    The perfect balance of everyday convenience and
                    practicality, the amenities of 618 Carnarvon provide an{' '}
                    <span>effortlessly elevated lifestyle.</span>
                  </p>
                }
              />
            </StyledParallax>
          </Image>
        </Parallax>

        <MobileText>
          The perfect balance of everyday convenience and practicality, the
          amenities of 618 Carnarvon give you an effortlessly elevated
          lifestyle.
        </MobileText>

        <StyledNextLine text={'Next: The Interiors'} link={'interiors'} />
        <RegisterButton />
      </Root>
    );
  }
}

export default Building;

const Root = styled.div`
  overflow-x: hidden;
`;

const Header = styled.div`
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  height: 200vh;
  /* margin-bottom: 200px; */
  transition: 0.5s ease;
  border-bottom: 10px solid ${({ theme }) => theme.colorDarkBlue};
  @media (min-width: ${media.smup}) {
    height: 250vh;
    margin-bottom: 0;
    border-bottom: 0;
  }
  h1 {
    font-family: ${({ theme }) => theme.fontMain};
    font-size: 32px;
    letter-spacing: 1.37px;
    text-align: center;
  }
`;

const StyledNextLine = styled(NextLine)`
  @media (min-width: ${media.smup}) {
    margin-top: -180px;
  }
`;

const Circle = styled.div`
  margin: 25vh 0;
  width: 50vh;
  height: 50vh;
  border: 1px solid white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontHeader};
  @media (min-width: ${media.smup}) {
    width: 55vh;
    height: 55vh;
  }
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 65vh;
    height: 65vh;
    transform: translate(-50%, -50%);
    border: 1px solid white;
    border-radius: 50%;
    @media (min-width: ${media.smup}) {
      width: 75vh;
      height: 75vh;
    }
  }
  h1 {
    text-align: center;
    line-height: 32px;
    color: white;
  }
`;

const StyledDarkCircle = styled(DarkCircle)`
  top: ${props => props.mobileTop};
  transform: translateY(30%);
`;

const MobileStyledDarkCircle = styled(DarkCircle)`
  top: ${props => props.mobileTop};
  background-color: transparent;
  color: rgba(0, 0, 0, 0.72);
  display: none;
  @media (min-width: ${media.smup}) {
    transform: translateY(30%);
    background-color: ${({ theme }) => theme.colorDarkBlue};
    color: white;
    display: flex;
    position: inherit;
  }
`;

const Image = styled.div`
  background-image: url(${props => props.image});
  position: relative;
  background-size: cover;
  background-position: center;
  height: 70vw;
  width: 100%;
  /* margin-bottom: 200px; */
  display: flex;
  justify-content: center;
  border-top: 10px solid ${({ theme }) => theme.colorDarkBlue};
  border-bottom: 10px solid ${({ theme }) => theme.colorDarkBlue};
  @media (min-width: ${media.smup}) {
    height: 100vh;
    margin-bottom: 0;
    border-top: 0;
    border-bottom: 0;
  }
`;

const StyledDownArrow = styled(DownArrow)`
  top: 96vh;
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const MobileText = styled.p`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fontMain};
  color: rgba(0, 0, 0, 0.72);
  font-size: 18px;
  text-align: center;
  line-height: 24px;
  width: 80%;
  margin: 0 auto;
  @media (min-width: ${media.smup}) {
    display: none;
  }
`;

const StyledParallax = styled(Parallax)`
  @media (min-width: ${media.smup}) {
    position: absolute;
    top: ${props => props.desktopTop};
    left: ${props => props.desktopLeft};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Building.js